<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">通知资讯</div>
      </nav-bar>
    </van-sticky>

    <van-cell title="添加新闻资讯" size="large" is-link to="AddNews"/>
    <van-tabs v-model="active" @click="activeOnChange">
      <van-tab title="通知"></van-tab>
      <van-tab title="资讯"></van-tab>
      <van-tab title="轮播图"></van-tab>
    </van-tabs>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in news" :key="item.id">
          <!--          <template slot="left">-->
          <!--          </template>-->
          <van-cell :border="false" :label="new Date(item.createDate).toLocaleString()"
                    value="<<滑动<<">
            <template #title>
              <span class="custom-title">{{ item.title }}</span>
              <van-tag v-if="item.ntype===1" type="success">通知</van-tag>
              <van-tag v-if="item.ntype===2" type="primary ">资讯</van-tag>
              <van-tag v-if="item.ntype===3" type="warning ">轮播图</van-tag>
            </template>
          </van-cell>
          <template slot="right">
            <van-button square type="danger" @click="delNews(item.id)" text="删除"/>
            <van-button square type="primary" @click="lookNews(item.id)" text="详情"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  Sticky,
  ActionSheet,
  NoticeBar,
  Row,
  Col,
  Tag
} from 'vant';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tag);
import {GetNewsListByType, DelNewsById} from "../../../network/news";

export default {
  name: "NewsList",
  components: {NavBar},
  data() {
    return {
      active: 0,

      news: [],

      //refresh
      refreshing: false,
      loading: false,
      finished: true,
    }
  },
  activated() {
    this.GetNews();
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.news = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.GetNews();
        this.isLoading = false;
      }, 1000);
    },
    GetNews() {
      GetNewsListByType(this.active + 1).then(res => {
        this.news = res;
      })
    },
    delNews(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要删除吗'
      }).then(() => {
        DelNewsById(id).then(res => {
            if (res) {
              this.news = this.news.filter(item => item.id != id);
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    activeOnChange() {
      this.GetNews();
    },
    lookNews(id) {

    },
  }
}
</script>

<style scoped>

</style>
